import { AppEnvironment } from 'types/appEnvironment';

export const APP_ENVIRONMENT__TESTING: AppEnvironment = 'testing';

export const APP_ENVIRONMENT__PRODUCTION: AppEnvironment = 'production';
